<template>
  <el-dialog
    title="物流跟踪信息"
    :visible.sync="dialogVisible"
    width="650px"
    top="15px"
    @open="open"
  >
    <div
      v-loading="ProcessingLoading"
      style="max-height: 800px;min-height: 200px;overflow-y: auto"
    >
      <el-divider content-position="left">
        境内段物流信息
      </el-divider>
      <div v-if="Processing.logisticCode" style="margin: 10px 0">
        <span>运单号：{{ Processing.logisticCode }}</span>
      </div>
      <div style="margin-left: 60px;max-height: 400px;overflow-y:auto">
        <rj-timeline class="Processing">
          <rj-timeline-item
            v-for="(pro, index) in Processing.traces"
            :key="index"
            :color="index != 0 ? '#909399' : ''"
          >
            <p>{{ pro.acceptStation }}</p>
            <p>{{ pro.acceptTime }}</p>
            <div v-if="index == 0" class="itemState">
              {{ $store.state.enumeration.LogisticsStatus[Processing.state] }}
            </div>
          </rj-timeline-item>
        </rj-timeline>
      </div>
      <no-data v-if="!Processing.logisticCode" />
      <div>
        <el-divider content-position="left">
          境外段物流信息
        </el-divider>
        <div class="rj-row">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                派送日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ intelLogisticsInfo.deliveryDate || "--" }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                清关日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ intelLogisticsInfo.customsClearanceDate || "--" }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                抵港日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ intelLogisticsInfo.arrivalDate || "--" }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                离境日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ intelLogisticsInfo.departureDate || "--" }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                报关日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ intelLogisticsInfo.customsDeclarationDate || "--" }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                提货日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ intelLogisticsInfo.pickUpDate || "--" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import noData from '@/components/noData';
import timeLine from 'rjelement-components/packages/components/timeLine';
import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import { getLogisticsInfoToList } from '@/API';
import { getIntelLogisticsDetailByFhNum } from '@/API/international';
export default {
  name: 'InternationalLogisticsInformationDialog',
  data () {
    return {
      dialogVisible: this.dialogVisibleFromLogistics,
      intelLogisticsInfo: {},
      ProcessingLoading: false,
      Processing: {}
    };
  },
  props: {
    dialogVisibleFromLogistics: {
      type: Boolean,
      default: false
    },
    currentClickData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    noData,
    'rj-timeline': timeLine,
    'rj-timeline-item': timeLineItem
  },
  methods: {
    open () {
      this.initData(this.currentClickData.logisticsNum, this.currentClickData.invoiceNum);
    },
    initData (val, invoiceNumber) {
      if (val) {
        this.Processing = {
          traces: []
        };
        this.ProcessingVisible = true;
        this.ProcessingLoading = true;
        getLogisticsInfoToList(val).then((res) => {
          let json = res.data;
          this.ProcessingLoading = false;
          if (json.status === '200') {
            this.Processing = json.data;
          }
        }).catch(() => {
          this.ProcessingLoading = false;
        });
      }
      if (invoiceNumber) {
        this.intelLogisticsInfo = {
        };
        getIntelLogisticsDetailByFhNum(invoiceNumber).then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data !== null) {
            this.intelLogisticsInfo = json.data;
          }
        }).catch(() => {
          this.ProcessingLoading = false;
        });
      }
    }
  },
  watch: {
    dialogVisibleFromLogistics (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  }
};
</script>
